define('components/ax-radio',[
	'core/can'
], function(can) {
	
	can.view.attr('ax-radio', function(el, data) {
		
		var attr = el.getAttribute('ax-radio');
		if (attr !== undefined) {
			new Checked (el, {
				value: data.scope.computeData(attr).compute
			});
		}
	});

	var Checked = can.Control.extend({		
		init: function(el, options) {
            this.check();
        },

        '{value} change': 'check',

        check: function() {
            
            if (this.options.value() === this.element.val()) {
                // This check is important because Bootstrap.js race condition
                if (!this.element.is(":checked")) {
	            	this.element.prop('checked', true);
	                this.element.parent('.btn').addClass('active');
	            }
            } else {
                this.element.prop('checked', false);
                this.element.parent('.btn').removeClass('active');
            }
        },

        'change': function() {
            if (this.element.is(":checked")) {
                this.options.value(this.element.val());
            }
        }
		
	})
});
